import { CSSProperties, ReactNode } from 'react';
import s from './LayoutMain.module.scss';
import { SurfaceColor } from 'common/components/utils.ts';

type LayoutMainProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  bgColor?: SurfaceColor;
  bottomSpacing?: 'auto-footer' | 'none' | number;
};

const LayoutMain = ({ children, className = '', style, bgColor, bottomSpacing = 'auto-footer' }: LayoutMainProps) => {
  return (
    <main
      className={`${s.layoutMain} ${className} ${typeof bottomSpacing === 'string' ? s[bottomSpacing] : ''} bg-${bgColor}`}
      style={{
        ...style,
        ...(typeof bottomSpacing === 'number' ? { marginBottom: `${bottomSpacing}px` } : {}),
      }}
    >
      {children}
    </main>
  );
};

export default LayoutMain;
